<template>
    <a class="options d-flex flex-row justify-content-center align-items-center"
       @click="goQuestions">
        <div class="options-content">
            <div :class="{'content-note': !bold, 'content-title': bold, 'font-weight-bold': bold}">{{text1}}</div>
            <div class="content-title font-weight-bold">{{text2}}</div>
        </div>
        <div class="options-picture d-flex justify-content-center align-items-center">
            <img :src="img"
                 alt="" />
        </div>
    </a>
</template>

<script>
export default {
    name: 'Options',
    props: {
        text1: String,
        text2: String,
        bold: Boolean,
        img: String,
        index: Number,
    },
    methods: {
        goQuestions() {
            this.$router.push(`/faq/questions/${this.index + 1}`);
        },
    }
};
</script>
<style lang="scss">
a:hover {
    text-decoration: none !important;
}
.options {
    cursor: pointer;
    border-radius: 6px;
    margin-bottom: 40px;
    margin-left: 1rem;
    margin-right: 1rem;
    width: 350px;
    height: 151px;
    background-color: #ecf6fc;
    &:focus {
        outline: 0;
    }
    @media (max-width: 793px) {
        width: 450px;
        margin-left: 0;
        margin-right: 0;
        margin-bottom: 20px;
    }
    &:first-child {
        margin-left: 0;
    }
    &:last-child {
        margin-right: 0;
    }
    .options-picture {
        background-image: url('../../assets/images/faq/icon-bg.svg');
        margin-left: 20px;
        width: 95px;
        height: 78px;
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
    }
    .options-content {
        .content-title {
            color: #333333;
            font-size: 28px;
            @media (max-width: 793px) {
                text-align: center;
                font-size: 30px;
            }
            @media (max-width: 360px) {
                font-size: 26px;
            }
        }
        .content-note {
            color: #666;
            @media (max-width: 793px) {
                text-align: center;
            }
            @media (max-width: 360px) {
                font-size: 16px;
            }
            font-size: 18px;
        }
    }
}
</style>
